import Rate from './Rate';
export default Rate;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-rate/src/index.js